import React from 'react';
import { Col, Row, Empty, Spin } from 'antd';
import { FilterCategoryTab, ProductSaleCard } from '..';
import InfiniteScroll from 'react-infinite-scroll-component';
import { ProductListPanelProps } from 'types/ProductType';

export const ProductListPanel: React.FC<ProductListPanelProps> = ({
  products,
  categories,
  loading,
  totalCount,
  hasMore,
  selectedCategoryId,
  setCategoryFilter,
  filterCategories,
  setFilterCategories,
  fetchMoreData,
}) => {
  const handleSelectCategory = (categoryId: string | null) => {
    setCategoryFilter(categoryId);
  };

  // Main loading indicator
  if (loading && products.length === 0) {
    return (
      <div className='flex justify-center items-center h-full'>
        <Spin size='large' />
      </div>
    );
  }

  return (
    <div>
      <FilterCategoryTab
        categories={categories}
        selectedCategoryId={selectedCategoryId}
        onSelectCategory={handleSelectCategory}
        allQuantity={totalCount}
        setFilterCategorys={setFilterCategories}
        filterCategorys={filterCategories}
        className='!mt-0'
      />

      {products.length === 0 ? (
        <Empty description='Không tìm thấy sản phẩm nào' className='mt-8' />
      ) : (
        <div id='scrollableDiv' className='overflow-auto h-[calc(100vh-170px)]'>
          <InfiniteScroll
            dataLength={products.length}
            next={fetchMoreData}
            hasMore={hasMore}
            loader={
              <div className='text-center py-4'>
                <Spin />
              </div>
            }
            endMessage={<p className='text-center py-4 text-gray-500'>Đã hiển thị tất cả sản phẩm</p>}
            scrollableTarget='scrollableDiv'
            className='!overflow-x-hidden'
          >
            <Row gutter={[16, 16]} className='mt-4'>
              {products.map((product) => (
                <Col key={product.id} xs={24} sm={12} md={8} lg={6}>
                  <ProductSaleCard product={product} />
                </Col>
              ))}
            </Row>
          </InfiniteScroll>
        </div>
      )}
    </div>
  );
};
